import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import styled from 'styled-components';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Typography, Box } from '@mui/material';
import { Grid } from '@mui/material';
import '../../microservice/container/sidebar.css';
import '../../Style/defaultstyle.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Sidebar from '../../container/Sidebar/Sidebar';
import '../../Style/defaultstyle.scss'
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';


const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;


// Titlecloudcompute
function EventSourcingVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Event Sourcing - Serverless Application - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Event Sourcing")} */}

                        <BoxContent>
                            <BoxText><p class="typo-14">• Dịch vụ dạng serverless để triển khai CQRS</p></BoxText>
                            <BoxText><p class="typo-14">• Lưu tất cả các sự kiện gây ra trạng thái của Application theo thứ tự — phương pháp cũ chỉ lưu trữ giá trị trạng thái cuối cùng</p></BoxText>
                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/event-sourcing-1.png"></ImageWrap>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <Box sx={TitleWrap}><Typography className="sub-title normal" sx={CardTitle} variant="h6"><p class="typo-21 typo-medium typo-black">Đặc điểm</p></Typography></Box>
                            <BoxText><p class="typo-14">• Mở rộng và bảo trì độc lập cho từng dịch vụ vi mô, có thể xây dựng và triển khai nhanh</p></BoxText>
                            <BoxText><p class="typo-14">• Các lỗi phát sinh sẽ chỉ ảnh hưởng đến chức năng đó, có thể sửa chữa và phục hồi nhanh chóng</p></BoxText>
                            <BoxText><p class="typo-14">• Hoạt động bất đồng bộ của ghi giúp chuyển đổi màn hình mà không cần đợi phản hồi xử lý</p></BoxText>
                            <BoxText><p class="typo-14">• Cấu hình cơ sở dữ liệu phía đọc</p></BoxText>
                            <BoxSubText><p class="typo-14">- Định nghĩa schema tối ưu cho các truy vấn</p></BoxSubText>
                            <BoxSubText><p class="typo-14">- Thực thi đọc tối ưu bằng các truy vấn đơn giản</p></BoxSubText>
                            <BoxSubText><p class="typo-14">- Có thể thay thế, tái cấu trúc toàn bộ cơ sở dữ liệu, hoặc phục hồi trạng thái cũ</p></BoxSubText>
                        </BoxContent>
                        <DividerComponent />

                        {/*}
                        <BoxContent>
                            <Box sx={TitleWrap}><Typography className="titlecard normal" sx={CardTitle} variant="h6">• 가격</Typography></Box>
                            <br/>
                            <CommonTable header={config.tb4_header} content={config.tb4_content} />
                            <br/>
                            <CommonTable header={config.tb5_header} content={config.tb5_content} />
                        </BoxContent>
                        */}
                        <BoxContent>
                            <Box><Typography className="sub-title normal" sx={CardTitle} variant="h6"><p class="typo-21 typo-medium typo-black">CQRS của AWS</p></Typography></Box>
                            {/* {Imagecloudcompute("https://www.hanbiro.com/cloud/library2/event-sourcing/event-sourcing-2.svg")} */}
                            <ImageWrap src="https://www.hanbiro.com/cloud/library2/event-sourcing/event-sourcing-2.svg"></ImageWrap>
                        </BoxContent>

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>


            <FooterVn />
        </Sysfont>
    );
};

const BoxSubText = styled.div`
  margin-left: 7%;
`

const CardTitle = {
    textAlign: "left",
    fontWeight: "bold",
    fontFamily: "맑은고딕, Dotum, 돋움, sans-serif !important;"
}

const TitleWrap = {
    height: "40px",
}


// const Box = styled.div`
//   @media only screen and (max-width: 767px){
//     font-size: 80%;
//   }
// `

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    margin: 0px !important;
    line-height: 2em;
`

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`

export default EventSourcingVN;
